import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { CollectionPointWithI18nKey } from '../../../../../types/collectionPoints';
import Item from './Item';
import './style.scss';

type ListProps = {
  locations?: CollectionPointWithI18nKey[];
  onItemClick: (id: string) => void;
  isLoading: string;
};

const List = (props: ListProps) => {
  const { locations, onItemClick, isLoading } = props;
  const hasLocations = !!locations?.length;
  return (
    <div className={classNames('collection-point-list', { 'collection-point-list--empty': !hasLocations })}>
      {!hasLocations && (
        <span className="collection-point-list__error">
          <FormattedMessage id="shipping.collectionPoint.list.noResults" />
        </span>
      )}
      {locations?.map(location => (
        <Item
          key={location.specification.collectionPointId}
          location={location}
          onClick={() => onItemClick(location.specification.collectionPointId)}
          isDisabled={!!isLoading}
        />
      ))}
    </div>
  );
};

export default List;
